(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mb-pullquote-scroll"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('[data-mb-quote]').forEach(function(root){
    var words = root.querySelectorAll('.mb-quote__w');
    function update(){
      var r = root.getBoundingClientRect();
      var vh = window.innerHeight;
      /* progress: 0 when section enters bottom, 1 when its middle passes 35% of viewport */
      var p = (vh * 0.85 - r.top) / (vh * 0.6);
      p = Math.max(0, Math.min(1, p));
      var n = Math.round(p * words.length);
      words.forEach(function(w, idx){ w.classList.toggle('is-on', idx < n); });
    }
    window.addEventListener('scroll', update, {passive:true});
    window.addEventListener('resize', update);
    update();
  });
})();

  } catch(e) { console.error(e); }
})();
})();
